import React, { PureComponent } from 'react';
import classnames from 'classnames';
import { IMAGE_PROP_TYPES } from '../constants/componentPropTypes';
import {
    RETINA_IMAGE_SUFFIX,
    ASSORTMENTS_MARKETING_PAGES_IMAGES,
} from '../constants/images';
import { hasRetinaScreen } from '@eb/feature-detection';

import Illustration from 'eventbrite_design_system/illustration/Illustration';

import './image.scss';

const _getImageSrc = (imagePath, isRetinaScreen, isSVG) => {
    const { suffix, standard, retina } = ASSORTMENTS_MARKETING_PAGES_IMAGES[
        imagePath
    ];
    let fileName = `${imagePath}${suffix}`;
    let fileHash = standard;
    const isRetina = isRetinaScreen && retina;

    if (isRetina && !isSVG) {
        fileName = `${imagePath}${RETINA_IMAGE_SUFFIX}${suffix}`;
        fileHash = retina;
    }

    return `//cdn.evbstatic.com/s3-build/perm_001/${fileHash}/django/images/assortments/${fileName}`;
};

export default class Image extends PureComponent {
    static propTypes = IMAGE_PROP_TYPES;

    static defaultProps = {
        bgPosition: 'center',
        verticalPadding: true,
        hasCenteredChildren: false,
        isFullWidth: true,
    };

    constructor(props) {
        super(props);

        const { illustration } = props;

        this.state = {
            isRetinaScreen: false,
            shouldRender: !!illustration,
        };
    }

    componentDidMount() {
        const isRetinaScreen = hasRetinaScreen();

        this._setRetinaState(isRetinaScreen);
    }

    _setRetinaState(isRetinaScreen) {
        const { imagePath, illustration } = this.props;

        this.setState({
            isRetinaScreen,
            shouldRender: imagePath || illustration,
        });
    }

    render() {
        const {
            __backgroundContainerClassName,
            altDescription,
            bgPosition,
            bgSize,
            children,
            height,
            illustration,
            imagePath,
            width,
            isFullWidth,
            isRound,
            isSVG,
        } = this.props;
        const { isRetinaScreen, shouldRender } = this.state;

        if (!shouldRender) {
            return null;
        }
        let imgSrc;
        const imgClassNames = classnames({
            'eds-max-img marketing-image--full-width': isFullWidth,
            'marketing-image--round': isRound,
        });

        if (imagePath) {
            imgSrc = _getImageSrc(imagePath, isRetinaScreen, isSVG);
        }

        let image = (
            <div className="eds-align--center">
                <img
                    className={imgClassNames}
                    alt={altDescription}
                    src={imgSrc}
                />
            </div>
        );

        if (height) {
            image = (
                <div className="eds-align--center">
                    <img
                        className={imgClassNames}
                        alt={altDescription}
                        src={imgSrc}
                        height={`${height}px`}
                    />
                </div>
            );
        }

        if (illustration) {
            image = (
                <Illustration
                    type={illustration}
                    width={`${width}px`}
                    height={`${height}px`}
                />
            );
        }

        if (children && !isSVG) {
            const style = {
                backgroundImage: `url(${imgSrc})`,
                backgroundRepeat: 'no-repeat',
                backgroundPosition: bgPosition,
                backgroundSize: bgSize,
                height: `${height}px`,
                width: `${width}px`,
            };

            image = (
                <div className={__backgroundContainerClassName} style={style}>
                    {children}
                </div>
            );
        }

        return image;
    }
}
